import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAppConfigObject } from "../../appConfig.interfaces";
import { decodeHtmlEntities } from "../../utils/helpers";

export const airportSearchApi: any = createApi({
  reducerPath: "airportSearchApi",
  baseQuery: fetchBaseQuery({
    method: "POST",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "POST, GET",
      "Access-Control-Allow-Origin": "*",
    },
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchAirports: builder.query({
      query: (arg: IFetchAirportsQuery) => {
        return {
          url: `${arg.config.LEGACY_LOCATIONS_API_BASE_URL}/suggest/${arg.query}?topLevelDomain=${arg.config.TOP_LEVEL_DOMAIN}`,
          method: "GET",
        };
      },
    }),
  }),
});
export const { useFetchAirportsQuery } = airportSearchApi;

interface IFetchAirportsQuery {
  query: string;
  limit: number;
  config: IAppConfigObject;
}
